import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderService } from '../services/order.service';
import { WebIdTransactionConfirmationService } from '../../services/web-id-transaction-confirmation.service';
import { WebIdAction } from '../../dto/web-id-action';
import {MatStepper} from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-web-id',
  templateUrl: './web-id.component.html',
  styleUrls: ['./web-id.component.css']
})
export class WebIdComponent implements OnInit {
  @ViewChild(MatStepper, { static: false }) matStepper: MatStepper;
  webIdTransactionSubscription: any;
  webIdResponse: any;
  webIdAction: WebIdAction;
  constructor(
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private webIdTransactionConfirmationService: WebIdTransactionConfirmationService,
  ) { }

  ngOnInit() {
    this.intializeWebIdIdentification();
  }

  intializeWebIdIdentification() {
    const orderId = this.route.snapshot.paramMap.get('id');

    this.orderService.createWebIdTransaction(orderId).subscribe(
      (data: WebIdAction) => {
          this.webIdAction = data;
          if (this.webIdTransactionSubscription != null) {
            this.webIdTransactionConfirmationService.closeConnection();
            this.webIdTransactionSubscription.unsubscribe();
          }

          this.webIdTransactionConfirmationService.init(data.transactionId);
          this.webIdTransactionSubscription = this.webIdTransactionConfirmationService
            .messageReceived.subscribe(
              (success: any) => {

                this.webIdResponse = success;
                this.matStepper.next();

                this.webIdTransactionConfirmationService.closeConnection();
                this.webIdTransactionSubscription.unsubscribe();
              },
              (error: Error) => {
                console.log(error);
              });

        },
      err => {
        const msg = ( err.error.message || err.error || err.message || err ) +
        '         ( Try to click \'Submit\' Again OR Check The Provided Data for Mistakes In Order To make sure Everything Is Ok! )';
        this.snackBar.open( msg , null, {
          duration: 5000,
          panelClass: [ 'app-mat-snack-bar' ]
        } );
      }
    );
  }

}
